import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { AdmRedePostosServices } from '../adm-rede-postos.service';
import { FiltrarGrupoEntidadeComponent } from '../filtrar-grupo-entidade/filtrar-grupo-entidade.component';

@Component({
  selector: 'app-criar-master',
  templateUrl: './criar-master.component.html',
  styleUrls: ['./criar-master.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSpinnerOverlayComponent,
    MatOptionModule,
  ],
})
export class CriarMasterComponent {
  public loading = false;
  public dialogRef = inject(MatDialogRef<CriarMasterComponent>);
  private service: AdmRedePostosServices = inject(AdmRedePostosServices);
  private snack = inject(SnackBarService);
  public dialog = inject(MatDialog);

  masterForm: FormGroup = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    dscemail: new FormControl('', [Validators.required, Validators.email]),
    codGrupo: new FormControl('', [Validators.required]),
    descricaoGrupo: new FormControl('', [Validators.required]),
  });

  limpaFiltro() {
    if (this.masterForm.get('descricaoGrupo')?.value) {
      this.masterForm.patchValue({
        codGrupo: undefined,
        descricaoGrupo: undefined,
      });
    }
  }

  openDialog() {
    if (this.masterForm.get('descricaoGrupo')?.value) {
      const dialogRef = this.dialog.open(FiltrarGrupoEntidadeComponent, {
        width: '50%',
        data: this.masterForm.get('descricaoGrupo')?.value,
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.masterForm.patchValue({
            codGrupo: result.codigoGrupo,
            descricaoGrupo: result.descricaoGrupo,
          });
        }
      });
    }
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  onConfirmar(): void {
    if (!this.masterForm.valid) {
      return;
    }
    this.loading = true;
    const result = this.masterForm.value;
    const novaMaster: any = {
      nome: result.nome,
      dscemail: result.dscemail,
      codigoGrupo: result.codGrupo,
    };

    this.service.criarAdmDeRede(novaMaster).subscribe(
      (response: any) => {
        this.loading = false;
        if (response && response.sucesso) {
          this.dialogRef.close(response);
        } else {
          this.loading = false;
          this.snack.flashMessage(
            response?.mensagens[0] || 'Erro ao criar nova Macro de Posto',
            ['snackbar-error'],
            'Fechar',
            3000
          );
        }
      },
      (error) => {
        this.loading = false;
        this.snack.flashMessage(
          'Erro ao criar nova Macro de Posto',
          ['snackbar-error'],
          'Fechar',
          3000
        );
      },
      () => {
        this.loading = false;
      }
    );
  }
}
